module.exports = __webpack_public_path__ + "static/9-Desktop-Insigh Article3-3ef401d05f13697242e31db3061cae3c.png";